<template>
  <div>
    <v-hover v-slot="{ hover }">
      <v-list-item @click="set_serie_attiva()" :class="{ 'green lighten-5': attiva }">
        <v-list-item-avatar
          style="cursor: pointer"
          :color="attiva ? 'green' : 'grey lighten-3'"
          class="mr-2 mt-2"
          size="40"
        >
          <v-img v-if="!img_error" :src="brand_img_url" @error="img_error = true">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-icon small :color="attiva ? 'white' : 'green'">mdi-sprout</v-icon>
              </v-row>
            </template>
          </v-img>
          <v-icon v-else :color="attiva ? 'white' : 'green'">mdi-sprout</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title :class="{ 'green--text font-weight-medium': attiva }">
            {{ serie.nome }}
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action class="flex-row align-center" style="gap:2px">
          <v-btn v-if="hover" small icon color="grey" @click.stop="apri_rename">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn v-if="hover" small icon color="red" @click.stop="dialog_elimina = true">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-hover>
    <v-dialog v-model="dialog_rename" width="400">
      <v-card>
        <v-card-title class="grey--text text-subtitle-1">Rinomina Serie</v-card-title>
        <v-card-text>
          <v-text-field
            outlined
            label="Nome"
            hide-details
            v-model="nome_nuovo"
            @keypress.enter="salva_rename"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialog_rename = false">Annulla</v-btn>
          <v-btn outlined color="green" @click="salva_rename" :loading="loading_rename">Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_elimina" width="400">
      <v-card>
        <v-card-title class="grey--text text-subtitle-1">Elimina Serie</v-card-title>
        <v-card-text>
          Sei sicuro di voler eliminare la serie <strong>{{ serie.nome }}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="grey" @click="dialog_elimina = false">Annulla</v-btn>
          <v-btn outlined color="red" @click="elimina_serie" :loading="loading_elimina">
            <v-icon class="mr-1">mdi-delete</v-icon>Elimina
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar_errore" color="error" bottom timeout="4000">
      <v-icon class="mr-2">mdi-alert-circle-outline</v-icon>
      Impossibile eliminare: la serie è collegata a delle varietà
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    id_specie: String,
    serie: Object,
    attiva: { type: Boolean, default: false },
  },
  data() {
    return {
      dialog_elimina: false,
      loading_elimina: false,
      snackbar_errore: false,
      img_error: false,
      dialog_rename: false,
      loading_rename: false,
      nome_nuovo: "",
    };
  },
  computed: {
    brand_img_url() {
      return `${process.env.VUE_APP_API_ROOT}/specie/${this.id_specie}/serie/${this.serie.id}/brand_img_serie`;
    },
  },
  methods: {
    elimina_serie() {
      this.loading_elimina = true;
      this.$store
        .dispatch("elimina_serie_specie", {
          id_specie: this.id_specie,
          id_serie: this.serie.id,
        })
        .catch(() => {
          this.snackbar_errore = true;
        })
        .finally(() => {
          this.loading_elimina = false;
          this.dialog_elimina = false;
        });
    },
    apri_rename() {
      this.nome_nuovo = this.serie.nome;
      this.dialog_rename = true;
    },
    salva_rename() {
      if (!this.nome_nuovo.trim()) return;
      this.loading_rename = true;
      this.$store
        .dispatch("rename_serie_specie", {
          id_specie: this.id_specie,
          id_serie: this.serie.id,
          nome: this.nome_nuovo.trim(),
        })
        .finally(() => {
          this.loading_rename = false;
          this.dialog_rename = false;
        });
    },
    set_serie_attiva() {
      this.$emit("set_serie_attiva", this.serie.id);
    },
  },
};
</script>
